// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__YsWEp","banner":"Banner_banner__XZq0T"};